<span class="spinner" [style.width.px]="diameter()" [style.height.px]="diameter()"></span>
